import React from 'react';
import { Modal } from '@odin-labs/components';
import { useReturnTempBadgeMutation } from 'apollo/generated/client-operations';
import { getGraphQLError } from 'utils/error';
import { AlertService } from 'components/alertService/AlertService';
import { TurnDownLeftIcon } from 'components/icons';
import { TempBadge } from 'containers/jobsite/tabs/jobsiteTempBadges/types';

export function ReturnTempBadgeModal(props: {
  isOpen: boolean;
  closeModal: () => void;
  onClosed: () => void;
  onConfirm: () => void;
  tempBadge: TempBadge;
}): React.ReactElement {
  const { isOpen, closeModal, onClosed, onConfirm, tempBadge } = props;

  const [returnTempBadge, { loading }] = useReturnTempBadgeMutation({
    fetchPolicy: 'no-cache',
    onCompleted: () => {
      onConfirm();
      AlertService.alert(
        'success',
        'Success',
        'Temporary badge successfully deactivated',
      );
    },
    onError: (error) => {
      AlertService.alert(
        'danger',
        'Something went wrong!',
        getGraphQLError(error),
      );
    },
    variables: { id: tempBadge?.id },
  });

  return (
    <Modal
      open={isOpen}
      setOpen={closeModal}
      afterLeave={onClosed}
      size="xs"
      title="Return temporary badge"
      titleAlignment="center"
      text="Would you like to return this temporary badge?"
      textAlignment="center"
      onAction={returnTempBadge}
      actionText="Return"
      actionIcon={TurnDownLeftIcon}
      actionButtonWithSpinner={loading}
    />
  );
}
